import React from 'react';

import Dropdown from 'components/base/Dropdown/Dropdown';
import { StyledDropdown } from '../styles';

import { ILabelValuePair } from 'types/shared';

type ItemType = ILabelValuePair<string>;

const items = [
  {
    label: 'All activity',
    value: 'all',
  },
  {
    label: 'Streaming activity',
    value: 'threshold',
  },
  {
    label: 'Playlist activity',
    value: 'playlist-priority',
    sublabel: 'Priority',
  },
  {
    label: 'Playlist activity',
    value: 'playlist',
    sublabel: 'All',
  },
  {
    label: 'Charts activity',
    value: 'chart',
  },
];

const ActivityDropdown: React.FC<{
  select: (item: ItemType) => void;
  selectedItem: ItemType | null;
}> = ({ select, selectedItem }) => (
  <StyledDropdown ml="52px" mb={4}>
    <Dropdown
      onChange={select}
      items={items}
      selectedItem={selectedItem}
      isActiveGreen={false}
      isScrolled
      placeholder="All activity"
    />
  </StyledDropdown>
);

export default ActivityDropdown;
